module.exports = __webpack_public_path__ + "static/all_day_area_text_behavior_example-d6602f9a0e931a31607ae43135ee44de.png";